import React, { FC, memo, useMemo } from 'react';
import { Tag } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    type?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { type } = props;

    const { color, text } = useMemo(() => {
        let color = '';
        let text = /* 手动创建 */UdeskLocales['current'].pages.trainingCenter.fastTraining.components.sentenceTypeTag.index.createManually;

        if (type === 3) {
            color = 'blue';
            text = /* 大模型扩充 */UdeskLocales['current'].pages.trainingCenter.fastTraining.components.sentenceTypeTag.index.largeModelExpansion;
        } else if (type === 2) {
            color = 'green';
            text = /* NLP自动扩充 */UdeskLocales['current'].pages.trainingCenter.fastTraining.components.sentenceTypeTag.index.nLPAutomaticExpansion;
        }

        return {
            color,
            text,
        };
    }, [type]);

    return <Tag color={color}>{text}</Tag>;
});

export default Template;
